var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdentity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(-3427 -590)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 120,
    height: 120,
    rx: 15,
    transform: "translate(3427 590)",
    fill: "#cffff5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(3436.583 598.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M29.981,40.626a1.532,1.532,0,0,0,1.564-1.5c0-10.2,8.653-18.5,19.289-18.5s19.289,8.3,19.289,18.5v9.746a1.565,1.565,0,0,0,3.128,0V39.126c0-11.855-10.057-21.5-22.417-21.5s-22.417,9.645-22.417,21.5A1.532,1.532,0,0,0,29.981,40.626Z",
    fill: "#359480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M29.981,45.626a6.65,6.65,0,0,0,6.776-6.5c0-7.444,6.313-13.5,14.073-13.5S64.9,31.682,64.9,39.126v9.746a6.821,6.821,0,0,0,6.95,6.667,1.5,1.5,0,1,0,0-3,3.752,3.752,0,0,1-3.823-3.667V39.126c0-9.1-7.715-16.5-17.2-16.5s-17.2,7.4-17.2,16.5a3.581,3.581,0,0,1-3.649,3.5,1.5,1.5,0,1,0,0,3Z",
    transform: "translate(0)",
    fill: "#359480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M29.981,50.626a11.765,11.765,0,0,0,11.988-11.5,8.869,8.869,0,0,1,17.722,0v9.746A11.936,11.936,0,0,0,71.853,60.539a1.5,1.5,0,1,0,0-3,8.867,8.867,0,0,1-9.035-8.667V39.126a12,12,0,0,0-23.977,0,8.7,8.7,0,0,1-8.861,8.5,1.5,1.5,0,1,0,0,3Z",
    transform: "translate(0 0.864)",
    fill: "#359480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M29.917,65.626a26.53,26.53,0,0,0,26.5-26.5,6.5,6.5,0,0,0-13,0,13.515,13.515,0,0,1-13.5,13.5,1.5,1.5,0,0,0,0,3,16.519,16.519,0,0,0,16.5-16.5,3.5,3.5,0,0,1,7,0,23.527,23.527,0,0,1-23.5,23.5,1.5,1.5,0,0,0,0,3Z",
    transform: "translate(0 1.299)",
    fill: "#359480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M29.917,60.626a21.525,21.525,0,0,0,21.5-21.5,1.5,1.5,0,0,0-3,0,18.521,18.521,0,0,1-18.5,18.5,1.5,1.5,0,0,0,0,3Z",
    transform: "translate(0 1.317)",
    fill: "#359480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M71.583,64.04a1.5,1.5,0,0,0-1.5-1.5,13.657,13.657,0,0,1-12.592-8.354,1.5,1.5,0,1,0-2.762,1.17A16.654,16.654,0,0,0,70.084,65.541,1.5,1.5,0,0,0,71.583,64.04Z",
    transform: "translate(1.833 1.867)",
    fill: "#359480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M64.177,78.051a1.482,1.482,0,0,0-1.046-1.885,31.464,31.464,0,0,1-9.521-4.647,1.707,1.707,0,0,0-1.864-.076A43.221,43.221,0,0,1,39.2,76.484,1.5,1.5,0,0,0,38.025,78.3a1.6,1.6,0,0,0,1.564,1.139,1.794,1.794,0,0,0,.389-.044,46.652,46.652,0,0,0,12.559-4.874,34.951,34.951,0,0,0,9.613,4.5A1.638,1.638,0,0,0,64.177,78.051Z",
    transform: "translate(0 2.749)",
    fill: "#359480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M68.726,73.877a1.509,1.509,0,0,0-1.262-1.752A25.462,25.462,0,0,1,55.571,66.6l-.591-.527a1.523,1.523,0,0,0-.176-.136,3.637,3.637,0,0,0-3.545-.25,1.725,1.725,0,0,0-.226.132l-.761.535a36.089,36.089,0,0,1-15.813,5.956A1.518,1.518,0,0,0,33.1,74a1.558,1.558,0,0,0,1.565,1.3,1.7,1.7,0,0,0,.213-.013,39.355,39.355,0,0,0,17.251-6.5l.628-.442a.268.268,0,0,1,.161.019l.557.494a28.691,28.691,0,0,0,13.4,6.225A1.582,1.582,0,0,0,68.726,73.877Z",
    transform: "translate(0 2.749)",
    fill: "#359480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M71.632,69.089a1.521,1.521,0,0,0-1.425-1.626A19.778,19.778,0,0,1,59.05,62.894a8.307,8.307,0,0,0-.7-.627c-.026-.024-.053-.046-.081-.068s-.067-.041-.1-.065-.049-.035-.076-.05a9.162,9.162,0,0,0-9.647-.613c-.031.014-.063.029-.093.045s-.053.023-.078.038-.077.048-.115.074l-1,.707a30.528,30.528,0,0,1-15.608,5.229,1.5,1.5,0,1,0,.085,3c.029,0,.059,0,.088,0A33.778,33.778,0,0,0,48.982,64.78l.005,0,.01-.007.014-.008.961-.681a5.8,5.8,0,0,1,6.274.411l0,0c.223.207.447.414.68.611h0a22.971,22.971,0,0,0,13,5.347A1.552,1.552,0,0,0,71.632,69.089Z",
    transform: "translate(0 2.154)",
    fill: "#359480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M53.136,79.1a18.763,18.763,0,0,1-3.221.278,1.5,1.5,0,0,0,0,3,21.823,21.823,0,0,0,3.736-.323,1.5,1.5,0,0,0-.515-2.955Z",
    transform: "translate(0.999 2.749)",
    fill: "#359480"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentity);
export default __webpack_public_path__ + "static/media/Identity.371265e9be2f90465727143817c9ab22.svg";
export { ForwardRef as ReactComponent };